// extracted by mini-css-extract-plugin
export default {"header":"o5pGsziG","timetable":"RK0isSvU scrollable","location":"dWeddPUW"};